import { Button } from 'components/atoms'
import { useVisibility } from 'hooks/useVisibility'
import { useRouter } from 'next/router'
import type { FC, ReactNode } from 'react'
import React, { useCallback, useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { pathENUM } from 'registrators/registrators'
import { setFetch } from 'store/reducers/app/appReducer'
import { getUser } from 'store/reducers/user/userReducer'
import type { RootState } from 'store/store'
import { useAppDispatch } from 'store/store'

import { redirectToESIA } from '../axios/utils'
import { BurgerMenuFromMobile } from './BurgerMenu/BurgerMenuFromMobile'
import { Cookie } from './Cookie/Cookie'
import { CatchTokenEsia } from './Esia/Esia'
import { Footer } from './Footer/Footer'
import { HeaderContent } from './Header/HeaderContent'
import { PagesList } from './PagesList/PagesList'
import {
  SFlexWrapp,
  SHeader,
  SLinkUser,
  SLogin,
  SLoginDesktop,
  SNavbarWrapp,
  SNavbarWrapper,
  SPageListWrapp,
  SPagesWrapper,
} from './styles/Navbar.styled'

interface IMainContainerProps {
  children: ReactNode
}

export const MainContainer: FC<IMainContainerProps> = ({ children }) => {
  const { pathname } = useRouter()
  const router = useRouter()
  const dispatch = useAppDispatch()
  const { fetch } = useSelector((state: RootState) => state.app)
  const visibility = useVisibility()
  const { user } = useSelector((state: RootState) => state.user)

  const onFetchSet = useCallback(() => {
    dispatch(setFetch(!fetch))
  }, [dispatch, fetch])

  const login = useMemo(() => {
    if (user) {
      return (
        <SLinkUser href={pathENUM.profile}>
          {`${user.person.first_name} ${user.person.last_name}`}
        </SLinkUser>
      )
    }
    return (
      <SLogin>
        <Button buttonStyle="default" onClick={() => redirectToESIA()}>
          Войти
        </Button>
      </SLogin>
    )
  }, [user])

  useEffect(() => {
    if (visibility === 'visible') {
      dispatch(getUser())
    }
  }, [dispatch, visibility])

  useEffect(() => {
    router.events.on('routeChangeStart', onFetchSet)
    router.events.on('routeChangeComplete', onFetchSet)
    router.events.on('routeChangeError', onFetchSet)

    return () => {
      router.events.off('routeChangeStart', onFetchSet)
      router.events.off('routeChangeComplete', onFetchSet)
      router.events.off('routeChangeError', onFetchSet)
    }
  }, [onFetchSet, router.events])

  return (
    <>
      <SNavbarWrapp>
        <SNavbarWrapper>
          <SHeader>
            <CatchTokenEsia />
            <HeaderContent />
          </SHeader>
          <SLoginDesktop>{login}</SLoginDesktop>
        </SNavbarWrapper>
        <BurgerMenuFromMobile login={login} />
        <SFlexWrapp>
          <SPageListWrapp>
            <PagesList />
          </SPageListWrapp>
        </SFlexWrapp>
      </SNavbarWrapp>
      <SPagesWrapper>
        {children}
        <Cookie />
      </SPagesWrapper>
      {pathname !== pathENUM.map && <Footer />}
    </>
  )
}
